import PageSectionTitle from './PageSectionTitle.client'

export default PageSectionTitle
